module.exports = __webpack_public_path__ + "img/banner-home.6c160ca7.png";